import React from 'react'
import styled from '@emotion/styled'
import dayjs from 'dayjs'
import { font, spacing } from '@mobi/component-library/Foundations'
import { hexColors } from '@mobi/settings/hexColors'
import { state$ } from '@core/Areas/MysteryBet/driver'
import { useObservableImmutable } from '@core/Utils/hooks'

export const MeetingInformation = (): JSX.Element | null => {
  const currentData = useObservableImmutable(state$, ['currentData']).currentData?.toJS()

  return (
    <WrapperStyled>
      <div>
        <div>
          {currentData?.Meeting?.MeetingId}
          <span>{currentData?.Race?.RaceNumber}</span>
        </div>
        <div>{dayjs(currentData?.Race?.RaceTime).format('HH:mm')}</div>
      </div>

      <div>
        <span>{currentData?.Meeting?.MeetingName}</span>
        <span>{currentData?.Race?.RaceName}</span>
      </div>
    </WrapperStyled>
  )
}

const WrapperStyled = styled.div({
  display: 'flex',
  gap: spacing.smx1,
  backgroundColor: hexColors.nero,
  color: hexColors.white,
  padding: `${spacing.sm} ${spacing.md}`,
  fontFamily: font.family.primary,
  fontWeight: font.weight.bold,

  '> div:first-of-type': {
    flexShrink: 0,
    textAlign: 'center',

    '> div:nth-of-type(1)': {
      display: 'flex',
      flexDirection: 'column',
      background: hexColors.sushi,
      padding: '0.5rem 1rem',
      lineHeight: '1em',

      '> span': {
        fontSize: font.size.xl3.fontSize,
        textAlign: 'center',
        lineHeight: '1em',
      },
    },

    '> div:nth-of-type(2)': {
      fontSize: font.size.md.fontSize,
    },
  },

  '> div:last-of-type': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

    '> span:nth-of-type(1)': {
      fontSize: font.size.xl.fontSize,
      lineHeight: font.size.xl.lineHeight,
      letterSpacing: font.size.xl.letterSpacing,
    },

    '> span:nth-of-type(2)': {
      fontSize: font.size.md.fontSize,
      lineHeight: font.size.md.lineHeight,
      letterSpacing: font.size.md.letterSpacing,
      color: hexColors.grey,
    },
  },
})
